import { cloneDeep, isArray } from 'lodash'
import { spliceArray } from '../../utils'
import { UPDATE_STORE_PARAMS } from '../../config'
import { getRowKeyIter } from '../config/utils'
import { createUuid } from '../config/data'


const expandMethods = {
  onRowExpanded({
    expanded,
    rowData,
    rowIndex,
    rowKey,
  }) {
    const {
      expandedRowKeys,
    } = this.states
    const { treeProps = {}, lazy, load, enableExpandRow } = this.table.$props
    const { children = 'children', hasChildren = 'hasChildren' } = treeProps
    const id = rowData[rowKey]
    const _expandedRowKeys = cloneDeep(expandedRowKeys)
    const currentKeyIndex = _expandedRowKeys.indexOf(id)

    const _update = (updateVirtualScrollStatus) => {
      this.commit(UPDATE_STORE_PARAMS, {
        expandedRowKeys: _expandedRowKeys,
      })
      this.updateTableData({
        isResetScroll: false
      })
      updateVirtualScrollStatus && this.virtualInstance.handleScroll(this.states.scrollPos.scrollTop) // 为什么会被注释。是因为重置了滚动条的问题
      this.table._updateTableHeight()
    }

    const _lazyLaodChildren = (data) => {
      const _rowData = this._tableData[rowIndex]
      _rowData && (_rowData[children] = data)
      if (!data || data.length === 0) {
        _rowData[hasChildren] = false
      }
      _update()
    }

    const setExpandedRowKeys = () => currentKeyIndex === -1 && _expandedRowKeys.push(id)

    if (expanded) {
      // 展开行-详情
      if (enableExpandRow) {
        spliceArray(this.states.loadingRow, id)
        setExpandedRowKeys()
        _update(true)
      } else {
        // 展开行
        setExpandedRowKeys()
        // 异步加载逻辑
        if (lazy && rowData[hasChildren] && !rowData[children]) {
          this.states.loadingRow.push(id)
          if (typeof load === 'function') {
            load(this._tableData, rowData, (data) => {
              _lazyLaodChildren(isArray(data) ? data : [])
              spliceArray(this.states.loadingRow, id)
            })
          } else {
            _lazyLaodChildren([])
            spliceArray(this.states.loadingRow, id)
          }
          return false
        }
      }
    } else {
      currentKeyIndex > -1 && _expandedRowKeys.splice(currentKeyIndex, 1)
    }
    _update(!!enableExpandRow)
  },
  clearExpandedRowKeys () {
    const { expandedRowKeys } = this.table.$props
    this.states.expandedRowKeys = []
    // 清空如果存在默认展开的选项需要回填回去
    if (Array.isArray(expandedRowKeys) && expandedRowKeys.length) {
      this.states.expandedRowKeys = cloneDeep(expandedRowKeys)
    }
  }
}

export default {
  data () {
    return {
      states: {
        expandedRowKeys: [],
        depthMap: {}
      }
    }
  },
  methods: expandMethods
}


export function expandedData(formatDataResult, { store, table } = {}) {
  const { rowKey, depthMap, expandedRowKeys, mergeRowspanMaps } = store.states
  const { treeProps, enableExpandRow } = table.$props
  const { children: childrenKeyName } = treeProps
  const _depthMap = cloneDeep(depthMap || {})
  if (!expandedRowKeys || !expandedRowKeys.length) return { tableData: formatDataResult.tableData, depthMap: _depthMap }
  const array = []
  const keysSet = new Set()
  expandedRowKeys.forEach(x => keysSet.add(x))
  let stack = formatDataResult.tableData.slice()
  if (enableExpandRow) {
    // 由于展开行是基于插槽，即mounted才能拿到。所以这里默认展开不会执行
    // 可手动设置延迟，或者重新给定参数，通过参数设置
    for (let i = 0; i < stack.length; i++) {
      const child = stack[i]
      array.push(child)
      const rowKye = getRowKeyIter(child, rowKey)
      if (keysSet.has(rowKye)) {
        array.push({
          ...child,
          [rowKey]: createUuid(),
          expandRowData: child,
          _expandRowSign: true
        })
      }
    }
  } else {
    const mergeRowMapsValues = Object.values(mergeRowspanMaps)
    // 递归处理，对需要展开的子级做铺平展开
    recursionFlatten(array, stack, _depthMap, rowKey, -1, keysSet, childrenKeyName, mergeRowMapsValues)
  }
  return { ...formatDataResult, tableData: array, depthMap: _depthMap }
}

function recursionFlatten(data, stack, internalDepthMap, rowKey, parantDepth, keysSet, childrenKeyName, mergeRowMapsValues = []) {
  const mergeRowCllback = {}
  for (let i = 0; i < stack.length; i++) {
    const child = stack[i]
    internalDepthMap[child[rowKey]] = parantDepth + 1
    data.push(child)
    if (
      keysSet.has(child[rowKey]) &&
      Array.isArray(child[childrenKeyName]) &&
      child[childrenKeyName].length > 0
    ) {
      const mergeRowInfo = mergeRowMapsValues.find(item => [item.mergeStartIndex, item.mergeEndIndex].includes(i))
      const _addDataCallback = () => recursionFlatten(data, child[childrenKeyName], internalDepthMap, rowKey, internalDepthMap[child[rowKey]], keysSet, childrenKeyName, mergeRowMapsValues)
      // 合并行命中
      if (mergeRowInfo) {
        const { mergeStartIndex, mergeEndIndex } = mergeRowInfo
        if (mergeStartIndex === i) {
          mergeRowCllback[`${mergeEndIndex}`] = _addDataCallback
        }
      } else {
        _addDataCallback()
      }
    }
    const _addDataCallback = mergeRowCllback[i]
    if (_addDataCallback) {
      _addDataCallback()
      mergeRowCllback[i] = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/expand.js